import React, { Component } from 'react';
import {
  Dropdown,
  Icon
} from 'semantic-ui-react';
import axios from 'axios';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'next/router';
import { Avatar } from '@classapp-tech/edna';

import Main from '../layouts/Main';
import { asset } from '../lib/Util';
import { getNodeEnv } from '../lib/env';
import Config from '../lib/Config';
import User from '../models/User';
import Enrollment from '../models/Enrollment';
import Loading from '../components/Loading';
import Modal from '../components/Modal';
import Card from '../components/Card';

/**
 * @param {string} name
 * @param {string} logo
 */
const trigger = (name, logo) => (
  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <div style={{
      display: 'flex', alignItems: 'center', overflow: 'hidden', whiteSpace: 'nowrap'
    }}
    >
      {logo}
      <span style={{ marginLeft: '10px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{name}</span>
    </div>
    <div className="coloured gray" style={{ display: 'flex' }}>
      <span style={{ marginRight: '5px' }}>Trocar</span>
      <Icon name="angle down" />
    </div>
  </span>
);

/**
 * @typedef {{
 *  id: number,
 *  key: number,
 *  value: string,
 *  text: string,
 *  image: JSX.Element,
 *  hasAccess: boolean,
 * }} OrganizationIndexItem
 */

/**
 * @typedef {{
 *  url?: {
 *   query?: {
 *     code?: string | number,
 *     address?: string,
 *   },
 *  },
 *  store: import('../lib/store').Store,
 *  router: import('next/router').Router,
 * }} Props
 * @extends {Component<Props>}
 */
class Index extends React.Component {
  /**
   * @param {Props} props
   */
  constructor(props) {
    super(props);
    this.state = {
      selectedOrganization: null,
      /**
       * TODO Use OrganizationProps instead
       * @type {OrganizationIndexItem[]}
       */
      organizations: [],
      loading: true,
      disabled: false,
      checked: false,
      notAuthorized: false,
      organizationPlan: ''
    };
  }

  async componentDidMount() {
    const { store, router } = this.props;
    const { user } = store;

    if (store && user && user.organizations) {
      const organizations = user.organizations.map((organization) => ({
        id: organization.id,
        key: organization.id,
        value: organization.fullname,
        text: organization.fullname,
        image: (
          <Avatar
            size={28}
            name={organization.fullname}
            src={organization.logoUri}
            style={{ marginRight: '8px', fontSize: '10px' }}
            bg={organization.logoUri && 'fafafa'}
          />
        ),
        hasAccess: organization.enrollmentSetup?.status === 'PAID' || organization.enrollmentSetup?.status === 'TRIAL'
      }));
      const selectedOrganization = organizations.find((organization) => organization.id === user.selectedOrganizationId);

      // @ts-ignore TODO BUG Redirect home if selectedOrganization is undefined
      if (selectedOrganization && selectedOrganization.hasAccess) {
        router.push('/periods');
        return;
      }

      // @ts-ignore
      const organizationPlan = await Enrollment.organizationPlan(user.accessToken, selectedOrganization.id);

      this.setState({
        organizations, selectedOrganization, organizationPlan, loading: false
      });
    } else {
      const hasCode = !!(this.props.url && this.props.url.query && this.props.url.query.code);
      this.setState({ loading: true, notAuthorized: !!hasCode });
      router.push('https://www.classapp.com.br/rematricula-online');
    }
  }

  handleLogout = () => {
    window.location.replace(`${Config.walle.uri[getNodeEnv()]}auth/`);
  }

  /**
   * @param {OrganizationIndexItem} selectedOrganization
   */
  handleChange = async (selectedOrganization) => {
    const { router, store } = this.props;
    User.setSelectedOrganization(selectedOrganization.id);
    // @ts-ignore TODO check if store.user exists
    store.setUser({
      ...store.user,
      selectedOrganizationId: selectedOrganization.id
    });

    this.setState({ selectedOrganization }, () => {
      if (selectedOrganization.hasAccess) router.push('/periods');
    });
  };

  /**
   * @param {{ preventDefault: any }} e
   */
  handleSignIn = (e) => {
    const { router } = this.props;
    e.preventDefault();
    // @ts-ignore
    router.push(Config.loginUri[getNodeEnv()]);
  }

  sendToSlack = async () => {
    const { store } = this.props;
    const { user } = store;
    try {
      // @ts-ignore
      const organizationName = user.organizations.filter((org) => org.id === user.selectedOrganizationId)[0].fullname;
      await axios({
        method: 'post',
        url: process.env.SLACK_WEBHOOK_URL,
        data: JSON.stringify({
          // @ts-ignore
          text: `*Nova contratação do matrículas de forma low touch :smile:*\nInstituição: ${organizationName}\nUsuário: ${user.fullname || 'Sem nome'}\nLink da instituição: ${Config.walle.uri[getNodeEnv()]}organizations/${user.selectedOrganizationId}`
        })
      }).catch((err) => console.log(err));
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @param {{ preventDefault: any }} e
   */
  handleCreateSetup = async (e) => {
    e.preventDefault();
    const { store, router } = this.props;
    const { user } = store;
    this.setState({ disabled: true });
    if (user && user.selectedOrganizationId) {
      const enrollmentSetup = await Enrollment.createEnrollmentSetup(user.accessToken, user.selectedOrganizationId);
      const organizationIndex = user.organizations.findIndex(({ id }) => id === user.selectedOrganizationId);

      store.setUser({
        ...user,
        organizations: user.organizations.map((organization, index) => (index === organizationIndex ? {
          ...organization,
          enrollmentSetup: { status: enrollmentSetup.data?.enrollmentSetup?.register?.status },
        } : organization)),
      });

      if (enrollmentSetup.errors && enrollmentSetup.errors.length > 0) {
        const errors = enrollmentSetup.errors[0].message;

        /* This condition is temporary */
        if (errors === 'Failed to set to set ownership to the enrollment setup entity: User already has this entity') {
          router.push('/periods');
          return;
        }

        console.error(errors);
        this.setState({ errors });
        console.log('erro');
      } else {
        console.log('redirect');
        this.sendToSlack();
        router.push('/periods');
      }
    } else {
      console.log('login ?');
      this.handleSignIn(e);
    }
  };

  redirectFree = () => {
    const { router } = this.props;
    /* Checar qual dos links seria o correto. O segundo está temporariamente setado */
    // router.push('https://www.classapp.com.br/matriculas');
    router.push('https://www.classapp.com.br/rematricula-online');
  }

  renderButtonSelect = () => {
    const { user } = this.props.store;
    const { organizations, selectedOrganization, disabled } = this.state;
    if (user && user.accessToken && organizations && organizations.length > 0) {
      if (!selectedOrganization) return <Loading width={20} height={20} />;
      return (
        <Dropdown
          className="dropdown"
          placeholder="Ordenar por"
          disabled={disabled}
          // @ts-ignore
          trigger={trigger(selectedOrganization.text, selectedOrganization.image)}
          pointing="top left"
          icon={null}
        >
          <Dropdown.Menu>
            <Dropdown.Header content="Suas Instituições" />
            {organizations.map((option) => (
              <Dropdown.Item
                onClick={() => this.handleChange(option)}
                // @ts-ignore Key is already specified in ...option
                key={option.value}
                {...option}
              />
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );
    }

    return (
      <button type="button" onClick={this.handleSignIn} className="transparent button-not-signin">
        <img alt="logo" width={24} height={24} src={asset('classapp-compact-logo.svg')} />
        Entrar com o ClassApp
      </button>
    );
  }

  render() {
    const {
      loading, disabled, checked, notAuthorized, organizationPlan
    } = this.state;
    const { store, router } = this.props;
    const { user } = store;

    if (loading) {
      return (
        <Main noHeader className="container-loading">
          <Loading width={40} height={40} />
        </Main>
      );
    }

    // @ts-ignore TODO Check if user is null
    const selectedOrganization = user.organizations.find((organization) => organization.id === user.selectedOrganizationId);
    // @ts-ignore TODO Check if selectedOrganization is undefined
    const hasAccess = selectedOrganization.enrollmentSetup?.status === 'PAID' || selectedOrganization.enrollmentSetup?.status === 'TRIAL';

    return (
      <Main noHeader topMenu store={store} className="landing">
        <div className="section">

          <div className="title">
            <text>Confirmar contratação de Matrículas</text>
          </div>
          <div className="legend">
            <text>
              Ao confirmar a contratação do serviço ClassApp Matrículas, você afirma estar de acordo com seus
              {' '}
              <a href={Config.terms.enrollment} target="_blank" rel="noreferrer"> termos aditivos de serviço.</a>
              <br />
              <br />
              O serviço será contratado para a seguinte instituição:
            </text>
          </div>
          {this.renderButtonSelect()}
          {
            organizationPlan.toLowerCase() === 'free'
              ? (
                <div className="free">
                  <text>
                    A escola selecionada faz parte do plano gratuito, acesse a nossa página para contratar.
                  </text>
                </div>
              )
              : (
                <div className="checkbox">
                  <input
                    checked={checked}
                    onChange={() => this.setState({ checked: !checked })}
                    type="checkbox"
                    style={{
                      height: 17.5, width: 17.5, minHeight: 17.5, minWidth: 17.5, marginRight: 12
                    }}
                  />
                  Estou ciente da cobrança e concordo que consultei a Instituição acima e tenho autorização para aderir ao serviço opcional do ClassApp Matrículas em nome da Instituição
                </div>
              )

          }

          {organizationPlan.toLowerCase() === 'free'
            ? <button style={{ marginBottom: '2%', width: '100%' }} type="submit" className="button price-button" onClick={() => this.redirectFree()}>Ir para o site</button>
            : <button disabled={!checked || disabled} style={{ marginBottom: '2%', width: '100%' }} type="submit" className="button price-button" onClick={hasAccess ? () => router.push('/periods') : this.handleCreateSetup}>Confirmar contratação</button>
          }
          <button className="transparent" type="button" style={{ width: '100%' }} onClick={() => this.handleLogout()}> Cancelar </button>

          {notAuthorized && (
            <Modal
              titleStyle={{ width: '100%', justifyContent: 'center' }}
              title="Sem Acesso"
              cancelEnabled={false}
              size="small"
              buttonsStyle={{ display: 'flex', justifyContent: 'center', margin: 0 }}
              customConfirm={<button type="submit" onClick={() => this.setState({ notAuthorized: false })}>Ok</button>}
            >
              <div style={{ fontSize: 16, width: 300, paddingTop: 24 }}>
                <Card src={asset('empty.png')} text="Você não tem permissões para usar esse serviço..." />
              </div>
            </Modal>
          )}
        </div>
      </Main>
    );
  }
}

export default inject('store')(observer(withRouter(Index)));
